import { useEffect, useState, createContext, useContext, useCallback } from "react";
import { publicApi } from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await publicApi.getSettings();
      setSettings(data);
    } catch (e) {
      // keep defaults
      setSettings({
        company_name: "B&J Electric Service LLC",
        phone: "240-383-9887",
        email: "bjelectricservice@gmail.com",
        service_area: "DC • Maryland • Virginia (DMV)",
        hours: "Mon–Sat: 7AM–7PM • 24/7 Emergency",
        tagline: "Powering the DMV with expert electrical service.",
        about: "",
        services: [],
      });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, loading, refresh, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error("useSettings must be within SettingsProvider");
  return ctx;
}
